import '../scss/frontend.scss';
import Popup from './parts/popup-window';
import { isInViewport } from './parts/helpers';
import toggleMobileMenu from './parts/header';
import animateTypingText, { zoomImage } from './parts/animations';
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    const AnimateFadeInElems = document.querySelectorAll('.js-animate-fadeIn');
    const AnimateFadeInElemsOnce = document.querySelectorAll('.js-animate-fadeIn-once');
    const AnimateSlideInElems = document.querySelectorAll('.js-animate-slideIn');
    const AnimateSlideBlocks = document.querySelectorAll('.js-animate-slideBlocks');
    const AnimateFullscreenImage = document.querySelectorAll('.block-fullscreen-intro__content');
    function checkInView() {
        [...AnimateFadeInElems].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__fadeIn');
            }
            else {
                item.classList.remove('animated__fadeIn');
            }
        });
        [...AnimateFadeInElemsOnce].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__fadeIn');
            }
        });
        [...AnimateSlideInElems].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__slideIn');
            }
            else {
                item.classList.remove('animated__slideIn');
            }
        });
        [...AnimateSlideBlocks].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animated__slideBlocks');
            }
        });
        [...AnimateFullscreenImage].forEach((item) => {
            var _a;
            if (isInViewport(item)) {
                (_a = item.closest('.block-fullscreen-intro')) === null || _a === void 0 ? void 0 : _a.classList.add('animated__fs_image');
            }
        });
    }
    popupInstance.init();
    toggleMobileMenu();
    animateTypingText();
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
        zoomImage();
        checkInView();
    });
    {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
        zoomImage();
        checkInView();
    }
}
window.document.addEventListener('DOMContentLoaded', ready);
